import { Plan, PlanDescription } from '@/api/typings/billing';

export const getPlanDescription = (plan: PlanDescription): string | undefined => {
    const plans: Record<Plan, string> = {
        enterprise: 'Enterprise',
        p_12: 'Preview 12 Products',
        p_18: 'Preview 18 Products',
        p_30: 'Preview 30 Products',
        p_unlimited: 'Preview Unlimited',
        pp_10: 'Preview + Production 10 Products',
        pp_12: 'Preview + Production 12 Products',
        pp_14: 'Preview + Production 14 Products',
        pp_18: 'Preview + Production 18 Products',
        pp_20: 'Preview + Production 20 Products',
        pp_21: 'Preview + Production 21 Products',
        pp_30: 'Preview + Production 30 Products',
        pp_unlimited: 'Preview + Production Unlimited',
        storage: 'Storage'
    };

    if (!plans[plan.Plan]) return;

    let description = `${plans[plan.Plan]} Plan`;
    if (plan.Discount) {
        description += ` - ${Number(plan.Discount).toFixed(0)}% Discount`;
    }
    return description;
};
